// src/components/Investment/ExitStrategy.jsx
import React from "react";
import { motion } from "framer-motion";
import "./ExitStrategy.css";
import { useLanguage } from "../../contexts/LanguageContext";

const ExitStrategy = () => {
  const { translations: tRaw } = useLanguage();
  const t = {
    investment: {},
    ...tRaw,
    investment: { ...tRaw?.investment },
  };

  return (
    <section className="exit-strategy-section">
      <div className="exit-container">
        <motion.h2
          className="exit-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {t.investment?.exitTitle || "Exit Strategy"}
        </motion.h2>

        <div className="exit-points">
          {/* Card 1 */}
          <motion.div
            className="exit-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: 0.1 }}
            whileHover={{ y: -4 }}
          >
            <div className="exit-icon icon-blue" aria-hidden>
              {/* refresh/arrows look */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M4 12a8 8 0 0 1 13.66-5.66" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <path d="M18 4v4h-4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <path d="M20 12a8 8 0 0 1-13.66 5.66" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <path d="M6 20v-4h4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>

            <h3 className="exit-card-title">
              {t.investment?.exitBuybackTitle || "Buy-Back"}
            </h3>
            <p className="exit-card-copy">
              {t.investment?.exitBuybackText ||
                "Equity investors can sell their shares after 2–3 years with 6x–10x profit multiplier, while normal investors can achieve 8x–15x returns through our comprehensive exit strategy."}
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div
            className="exit-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: 0.2 }}
            whileHover={{ y: -4 }}
          >
            <div className="exit-icon icon-purple" aria-hidden>
              {/* bank/building look */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 9l9-5 9 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 10h16v8H4z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 10v8M12 10v8M16 10v8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>

            <h3 className="exit-card-title">
              {t.investment?.exitPublicTitle || "Public or Strategic Sale"}
            </h3>
            <p className="exit-card-copy">
              {t.investment?.exitPublicText ||
                "iWinto aims to be listed on Gulf or global stock exchanges or be acquired by major tech groups as a long-term exit."}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ExitStrategy;
